import { Days } from '../types/days'

export const weekdays: Days[] = ['mon', 'tues', 'wed', 'thurs', 'fri', 'sat', 'sun']
